import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { MSpinner } from "components/Shared";
import { PhotoTool } from "components/Photos";
import { ReviewCase } from "containers/Homeowner/Customer";
import UcdpSubmittalForm from "components/Homeowner/Appraisal/UcdpSubmittalForm";
import {
  CaseHeader,
  CompSearch,
  TrendCharts,
  Sketch,
  OrderRequirements,
  CubiCasaSketch,
  RctFrameWrapper,
  QACaseAudit,
} from "components/Homeowner/CaseForms";
import CaseHeaderV2 from "components/Homeowner/CaseForms/CaseHeaderV2/CaseHeaderV2";
import BrokerCaseHeader from "components/Broker/BrokerCaseHeader";
import { Validation } from "components/Homeowner/CaseForms/Validations";
import {
  CompSearch as ReadOnlyCompSearch,
} from "components/Homeowner/CaseForms/ReadOnly";
import { UNMOUNT_STATUS_ALLOW, UNMOUNT_STATUS_WARNING } from "components/Shared/MSection.tsx";
import MSectionCollection, { ACTION_SPLIT, ACTION_SPLIT_LEFT, MSECTION_MODE_TAB } from "components/Shared/MSectionCollection";
import Appraisal1004p from "components/Homeowner/CaseForms/Appraisal1004P/Appraisal1004p";
import Appraisal1004p70h from "components/Homeowner/CaseForms/Appraisal1004P70H/Appraisal1004p70h";
import Appraisal1004d from "components/Homeowner/CaseForms/Appraisal1004d";
import ReoMit from "components/Homeowner/CaseForms/REOMIT/REOMIT";
import ReoRepair from "components/Homeowner/CaseForms/REOMIT/ReoRepair";
import MitUpdate from "components/Homeowner/CaseForms/REOMIT/MitUpdate";
import TabbedHistory from "components/Homeowner/History/TabbedHistory";
import { isCustomer, isAppraisalCase, getCaseType, isValOrCusRole } from "components/Shared/Functions";
import { Calc, CaseDetails, Exports } from "components/QualityAssurance";
import { WrappedMSplitTabView } from "components/Shared/MSplitTabView/";
import MCaseViewTracker from "containers/Homeowner/MCaseViewTracker";
import FileManager from "./FileManager";
import {
  FORM_PHOTO_VIEWER_SPLIT_VIEW,
  CASE_FILE_REGENERATE_REPORT_PDF,
  APPRAISER_VIEW,
  CASE_HEADER_RIGHT_FILTERED_VIEW,
  APPRAISER_TIMELOGS_APPROVE,
  APPRAISER_TIMELOGS_APPROVE_VIEW,
  BUSOPS_TIMELOGS_APPROVE,
  BUSOPS_TIMELOGS_VIEW,
  CASE_TIMELOGS_VIEW_ALL, FIELD_REP_TIMELOGS_APPROVE_VIEW, MY_TIMELOGS_VIEW,
  APPRAISAL_GAAR_VIEW,
  INSPECTION_EVENT_WATCH,
  APPRAISAL_EVENT_WATCH,
  CASE_FORMS_MAINTENANCE,
} from "typeConstants/rights";
// Actions
import {
  formStatusChange,
  getCaseForms,
  getFiles,
  getHistory,
  importMismo,
  savePNXFormSuccess,
  savePNXFormFail,
  savePNXFormsMessage,
  validateForms,
  validationMessage,
  getCaseHeader,
  getWorkflowStatus,
} from "actions/homeowner/caseforms";
import { changeControlNumber } from "actions/homeowner/dashboard";
import { getCaseHazards } from "actions/qualityAssurance";
import { getCaseTimeLogByCase } from "actions/casetimelog";
import { getValidationStatus, getValidationIssues, getGaarResults } from "actions/validation";
import { getEnabledFeatures } from "actions/customer";
import responseHandler from "responseHandler";
import FilePreview from "containers/Homeowner/MCaseView/FileManager/FilePreview";
import { CASE_EMAIL_TAB_ID, CUSTOMER_SERVICE_EMAIL_TAB_ID } from "components/Homeowner/CaseForms/Actions";
import { validateComparables, validateComparablesPhoenix } from "requests/comparables";
import TabMap from "components/QualityAssurance/Sections/Map/TabMap";
import Appraisal1004Desktop from "components/Homeowner/CaseForms/Appraisal1004Desktop/Appraisal1004Desktop";
import { APPRAISAL_PORT_HOLD_TAB_ID, APPRAISAL_PORT_MESSAGE_TAB_ID } from "components/Homeowner/CaseForms/Actions/OnHold/AppraisalPort";
import { APPRAISAL_INTEGRATION_UCDP, APPRAISAL_INTEGRATION_GAAR } from "typeConstants/customerFeatures";
import AppraiserProfilePanel from "containers/Appraiser/ProfilePanel";
import Appraisal1004Desktop70D from "components/Homeowner/CaseForms/Appraisal1004Desktop70D/Appraisal1004Desktop70D";
import { PrimaryStatus } from "typeConstants/caseStatusCodes";
import { getEnabledFeatures as requestEnabledFeatures } from "requests/customer";
import CaseWatchDialog from "components/Homeowner/CaseDetails/CaseWatchDialog";
import { appendHeader, clearHeaderDefinitions, clearHeader } from "actions/layout";
import { userHasRight } from "selectors/rights";
import { CASE_DATA_REVISIONS_REJECTION } from "components/Homeowner/CaseFormDataRevisions";
import { Cell, Button } from "react-md";
import ThreeSixtyValue from "components/QualityAssurance/Sections/Calc/ThreeSixtyValue";
import E2Value from "components/QualityAssurance/Sections/Calc/E2Value.tsx";
import {
  setupSignalRConnection,
  SignalRConnectionStatus_Connected,
  SignalRConnectionStatus_Disconnected,
} from "middlewares/signalrAspNet";
import WebConfig from "middlewares/WebConfig";
import { PhoenixFormInstance, PhoenixFormsContext } from "components/PhoenixFormsV4/index.tsx";
import ManageFormsDialog from "components/QualityAssurance/Other/ManageFormsDialog.tsx";
import { manageFormsRedux } from "requests/homeowner/ho";
import { WindowContext } from "components/Shared/WindowProvider.tsx";
import {
  PHOTOS_BROADCAST_CHANNEL_NAME,
  PHOTOS_BROADCAST_PHOTO_EDITED_TYPE,
  PHOTOS_BROADCAST_SAVE_PHOENIX_FORMS,
  PHOTOS_BROADCAST_RELOAD_PHOTOS,
  PHOTOS_BROADCAST_CREATE_PHOENIX_FORMS_SAVE_SUBSCRIPTION
} from "typeConstants/photos/photos.ts";
import { debounce } from "lodash";
import { savePreference, loadPreference } from "requests/preferences/index.ts";

const LEFT_FORMS_TAB_ID = "forms";
const RIGHT_FORMS_TAB_ID = "right-forms";

class MCaseView extends MCaseViewTracker {
  static contextType = PhoenixFormsContext;

  constructor(props) {
    super(props);

    this.mapCaseFormsToComps = this.mapCaseFormsToComps.bind(this);
    this.navBlock = this.navBlock.bind(this);
    this.closeBlock = this.closeBlock.bind(this);
    this.refresh = this.refresh.bind(this);
    this.getAppraisalData = this.getAppraisalData.bind(this);
    this.getUnmountWarning = this.getUnmountWarning.bind(this);
    this.isFormStatusClean = this.isFormStatusClean.bind(this);
    this.canUnmountForm = this.canUnmountForm.bind(this);
    this.getLeftSideFormIndexFromTabIndex = this.getLeftSideFormIndexFromTabIndex.bind(this);
    this.cleanForm = this.cleanForm.bind(this);
    this.fixFormTitle = this.fixFormTitle.bind(this);
    this.formStatusChange = this.formStatusChange.bind(this);
    this.handleControlNumber = this.handleControlNumber.bind(this);
    this.findSectionIndexByTitle = this.findSectionIndexByTitle.bind(this);
    this.openFilePreview = this.openFilePreview.bind(this);
    this.splitAllFormsRight = this.splitAllFormsRight.bind(this);
    this.onTabSplit = this.onTabSplit.bind(this);
    this.getTabs = this.getTabs.bind(this);
    this.splitFormsTab = this.splitFormsTab.bind(this);
    this.getTabUnmountStatus = this.getTabUnmountStatus.bind(this);
    this.onTabUnmount = this.onTabUnmount.bind(this);
    this.openCompPhotoTool = this.openCompPhotoTool.bind(this);
    this.setPhotoControlMethods = this.setPhotoControlMethods.bind(this);
    this.openCaseActionTab = this.openCaseActionTab.bind(this);
    this.openCaseMap = this.openCaseMap.bind(this);
    this.openPhotoTool = this.openPhotoTool.bind(this);
    this.setInitialTab = this.setInitialTab.bind(this);
    this.updateCaseActions = this.updateCaseActions.bind(this);
    this.caseHeaderCallback = this.caseHeaderCallback.bind(this);
    this.enabledFeaturesCallback = this.enabledFeaturesCallback.bind(this);
    this.getAppraisalValidationResults = this.getAppraisalValidationResults.bind(this);
    this.caseHazardsRefresh = this.caseHazardsRefresh.bind(this);
    this.getHeaderDefinitions = this.getHeaderDefinitions.bind(this);
    this.getCaseWatchDialog = this.getCaseWatchDialog.bind(this);
    this.signalRStateChanged = this.signalRStateChanged.bind(this);
    this.startSignalRConnection = this.startSignalRConnection.bind(this);
    this.onReceiveEventOnCase = this.onReceiveEventOnCase.bind(this);
    this.disconnectSignalR = this.disconnectSignalR.bind(this);
    this.onPopOutPhotosButtonHit = this.onPopOutPhotosButtonHit.bind(this);
    this.getPhotoToolsOpenInOtherWindowMessage = this.getPhotoToolsOpenInOtherWindowMessage.bind(this);
    this.addEditedPhotoId = this.addEditedPhotoId.bind(this);
    this.caseFormsRefresh = this.caseFormsRefresh.bind(this);
    this.openSketchPopout = this.openSketchPopout.bind(this);
    this.closeSketchPopout = this.closeSketchPopout.bind(this);
    this.saveTabPreferences = debounce(this.saveTabPreferences.bind(this), 2000);
    this.parseTabPreference = this.parseTabPreference.bind(this);
    this.mergeTabIds = this.mergeTabIds.bind(this);

    this.lastRenderedTabs = null;
    this.uniqueTabString = [];
    this.pushedPhotosToPane = false;
    this.tabControlMethods = null;
    this.photoToolControlMethods = null;
    this.selectedPhotoIndex = null;
    this.broadcastChannel = new BroadcastChannel(PHOTOS_BROADCAST_CHANNEL_NAME);
    this.newWindow = null;
    this.sketchPopoutWindow = null;

    this.mounted = { current: true };
    
    this.signalrConnectionHub = React.createRef();
    this.signalRStateRef = React.createRef(SignalRConnectionStatus_Disconnected);
    this.signalR_ReconnectDelay = React.createRef(1000);
    this.canWatchCase = props.hasInspectionWatchRight || props.hasAppraisalWatchRight;
    this.hasHeaderButtons = props.canEditCaseForms || this.canWatchCase;
    this.caseWatchButtonObj = {
      name: "Watch",
      onClick: () => {
        this.setState({ showCaseWatchDialog: true });
      }
    };
    this.manageFormsButtonObj = {
      name: "Manage Forms",
      onClick: () => this.props.manageForms(true),
    };
    this.reloadOnSaveCleanupFunc = null;
    this.broadcastOnSaveCleanupFunc = null;

    this.state = {
      controlNumber: 0,
      blocking: false,
      blockRef: props.history.block(location => this.navBlock(location)),
      awaitingValidation: false,
      reloading: false,
      tabIndexInPanel: null,
      tabIndex: 0,
      addTabCounter: 1000, //to keep track of new tabs added to the view, use this as their order so new tabs just always show up at the end, dont use as their id because then we will be able to open multiple
      defaultLeftTabs: null,
      defaultRightTabs: null,
      isSplitting: !!props.forcePushToPane.length,
      comparableValidationResult: [],
      initialTabs: {},
      enabledFeatures: [],
      showCaseWatchDialog: false,
      showWatchButton: false,
      rightSideFormIndices: [], // number[] that represents index of forms (actual forms, not every tab that we call a form for some stupid reason) that we need to put on the right side in their own forms tab
      isPhotoTabPoppedOut: false,
      newWindowPhotos: null,
      editedPhotoIds: [],
      isSketchPopOutOpen: false,
      loadedTabPreference: null, // { leftTabIds: string[], rightTabIds: string[] }
    };
  }

  UNSAFE_componentWillMount() {
    super.UNSAFE_componentWillMount();
    if (this.props.initialTabs) {
      this.setState({ initialTabs: this.props.initialTabs });
    }
  }

  componentDidMount() {
    window.addEventListener("beforeunload", this.closeBlock);
    if (this.props.controlNumberOverride) {
      this.handleControlNumber(this.props.controlNumberOverride);
    } else if (this.props.location.state && this.props.location.state.controlNumber != null) {
      let id = parseInt(this.props.location.state.controlNumber);
      this.handleControlNumber(id);
    } else if (this.props.controlNumber !== 0) {
      this.handleControlNumber(this.props.controlNumber);
    } else {
      this.props.makeToast("Missing Control Number in MCaseView.", "error");
    }
    if (this.hasHeaderButtons) {
      this.props.appendHeader(this.getHeaderDefinitions());
    }
    if (this.broadcastChannel) {
      this.broadcastChannel.onmessage = (event) => {
        switch (event.data.type) {
          case PHOTOS_BROADCAST_CREATE_PHOENIX_FORMS_SAVE_SUBSCRIPTION:
            this.reloadOnSaveCleanupFunc = this.context.subscribeToOnSaveSuccess(this.context.reload);
            break;
          case PHOTOS_BROADCAST_SAVE_PHOENIX_FORMS:
            this.context.save();
            break;
          case PHOTOS_BROADCAST_PHOTO_EDITED_TYPE:
            this.setState({ editedPhotoIds: event.data.payload });
        }
      };
      this.broadcastOnSaveCleanupFunc = this.context.subscribeToOnSaveSuccess(() => {
        this.broadcastChannel.postMessage({
          type: PHOTOS_BROADCAST_RELOAD_PHOTOS
        });
      });
    }

    if (this.props.preferenceNameToSaveTabOrder) {
      loadPreference(this.props.preferenceNameToSaveTabOrder, this.parseTabPreference, this.mounted);
    }
  }

  componentWillUnmount() {
    super.viewSwitch();
    this.state.blockRef();
    this.mounted.current = false;
    window.removeEventListener("beforeunload", this.closeBlock);
    if (this.hasHeaderButtons)
      this.props.clearHeaderDefinitions(this.getHeaderDefinitions());
    // Disconnect SignalR on component unmount
    this.disconnectSignalR();
    this.newWindow?.close();
    this.newWindow = null;
    this.sketchPopoutWindow?.close();
    this.sketchPopoutWindow = null;
    this.broadcastChannel.close();
    this.broadcastOnSaveCleanupFunc?.();
    this.reloadOnSaveCleanupFunc?.();
  }

  componentDidUpdate() {
    const { isSaving, needsSave } = this.context;

    if (this.prevIsSaving && !isSaving) { // phoenix forms save finished
      if (needsSave) {
        this.props.savePNXFormFail("Save Error", "error");
      }
      else {
        this.props.savePNXFormSuccess("Save Successful", "success");
        this.refresh();
      }
    }
    let dirtyForms = this.props.caseForms.filter(item => {
      if (!this.canUnmountForm(item.formStatus)) {
        return true;
      }
    });
    if (this.state.blocking !== (dirtyForms.length > 0 || needsSave)) {
      this.setState({ blocking: dirtyForms.length > 0 || needsSave });
    }
    if (this.props.controlNumberOverride && (this.props.controlNumberOverride !== this.state.controlNumber)) {
      this.handleControlNumber(this.props.controlNumberOverride);
    }
    if (this.canWatchCase && !this.state.showWatchButton) {
      this.setState({showWatchButton: true});
      this.props.appendHeader({ buttons: this.caseWatchButtonObj });
    }
    if (!this.canWatchCase && this.state.showWatchButton) {
      this.setState({showWatchButton: false});
      this.props.clearHeaderDefinitions(this.getHeaderDefinitions());
    }
    // If there's a cleanup func for reloading on save but we don't have the new photo window popped out anymore, clean up the func.
    // Otherwise, if they keep popping it out before this component unmounts we'll have multiple subscriptions
    if (!this.state.isPhotoTabPoppedOut) {
      this.reloadOnSaveCleanupFunc?.(); 
    }
    // componentDidUpdate does not track context changes, saving as a "ref"
    this.prevIsSaving = isSaving;

    if (
      !this.props.fetchingCaseForms &&
      this.tabControlMethods &&
      this.state.loadedTabPreference &&
      (this.state.loadedTabPreference.leftTabIds?.length + this.state.loadedTabPreference.rightTabIds?.length > 0) // make sure we have tab data, otherwise we want to respect the default tab order
    )
    {
      let tabs = this.getTabs();
      let uniqueTabString = tabs.sort((a, b) => a.id.localeCompare(b.id)).map(t => t.id).join(",");
      
      // tabs set for the first time or changed
      if (uniqueTabString !== this.uniqueTabString) {
        let mergedTabs = this.mergeTabIds(tabs.map(t => t.id), [], this.state.loadedTabPreference.leftTabIds, this.state.loadedTabPreference.rightTabIds, "preference");
        
        if (mergedTabs.rightTabIds.includes(RIGHT_FORMS_TAB_ID)) {
          this.splitAllFormsRight();
        }
        this.tabControlMethods.forceSetTabs(mergedTabs.leftTabIds, mergedTabs.rightTabIds);
        this.uniqueTabString = uniqueTabString;
      }
    }
  }

  // SignalR Messages
  signalRStateChanged(e, data) {
    this.signalRStateRef.current = data;
    if (data.newState === SignalRConnectionStatus_Connected){
      this.signalR_ReconnectDelay.current = 1000;
    }
    if (this.signalrConnectionHub.current && data.newState === SignalRConnectionStatus_Disconnected) {
      window.setTimeout(() => {
        this.signalrConnectionHub.current.start();
      }, this.signalR_ReconnectDelay.current);
      this.signalR_ReconnectDelay.current += 1000;
    }
  }

  startSignalRConnection() {
    if (this.signalrConnectionHub.current && this.signalRStateRef.current.newState === SignalRConnectionStatus_Disconnected) {
      // Reconnect SignalR if the connection is disconnected
      this.signalrConnectionHub.current = null;
    }
    if (!this.signalrConnectionHub.current) {
      // Create a new SignalR connection
      let connectionFunc = setupSignalRConnection(
        WebConfig.signalrConnectionRoot, "CaseEventHub",
        {
          ControlNumber: this.props.controlNumberOverride ?? this.props.controlNumber,
          SSO: this.props.signalrToken
        },
        {
          ReceiveEventOnCase: this.onReceiveEventOnCase
        },
        () => {
          return this.props.signalrToken;
        });
      this.signalrConnectionHub.current = this.props.initSignalR(connectionFunc)
        .then((v) => {
          if (!v.events.onStateChanged) {
            v.events.onStateChanged = [];
          }
          v.events.onStateChanged.push(this.signalRStateChanged);
          v.reconnectWindow = Math.max(v.reconnectWindow, 120000); // Try reconnecting for at least 120 seconds
          v.serverTimeoutInMilliseconds = Math.max(v.serverTimeoutInMilliseconds, v.reconnectWindow * 2, 240000); // Try reconnecting for at least 120 seconds
          this.signalrConnectionHub.current = v;
        });    
    }
  }

  disconnectSignalR() {
    const localSignalRHub = this.signalrConnectionHub.current;
    this.signalrConnectionHub.current = null;
    localSignalRHub && localSignalRHub.stop(true, true);
  }

  onReceiveEventOnCase(message) {
    if (this.mounted.current && message.ControlNumber == this.state.controlNumber 
    ) {
      // Travelers hazards update from task processor
      if (message.Molecule === "TaskProcessor" 
      && message.ObjectName === "TravelersStackCode"
      && message.EventType === "Finished") {
        this.caseHazardsRefresh();
        this.props.makeToast("Case hazards updated", "success");
      }
    }
  }

  parseTabPreference(pref) {
    try { // dont want a bad parse to break the page
      // tabs is { leftTabs, rightTabs } each an array of tab ids (strings)
      let tabs = JSON.parse(pref.value);
      this.setState({ loadedTabPreference: { leftTabIds: tabs?.leftTabIds ?? [], rightTabIds: tabs?.rightTabIds ?? [] }});
    } catch {
      this.setState({ loadedTabPreference: { leftTabIds: [], rightTabIds: [] } });
    }
  }

  getHeaderDefinitions() {
    let defs = {
      buttons: []
    };

    if (this.canWatchCase) {
      defs.buttons.push(this.caseWatchButtonObj);
    }

    if (this.props.canEditCaseForms) {
      defs.buttons.push(this.manageFormsButtonObj);
    }

    return defs;
  }

  getCaseWatchDialog() {
    return (
      <CaseWatchDialog
        internetUserId={this.props.internetUserId}
        controlNumber={this.props.controlNumber}
        isLenderCase={this.isLenderCase}
        onClosed={() => this.setState({showCaseWatchDialog: false})}
      />);
  }

  handleControlNumber(newControlNumber, forceRefresh = false) {
    const { initializePhoenix } = this.context;
    
    if (newControlNumber && (this.state.controlNumber !== newControlNumber || forceRefresh)) {
      this.newWindow?.close();
      this.newWindow = null;
      this.props.changeControlNumber(newControlNumber);
      this.setState({
        controlNumber: newControlNumber,
        awaitingValidation: false
      });
      this.closeSketchPopout();
      this.props.getCaseForms(newControlNumber);
      this.props.getCaseTimeLogByCase(newControlNumber, this.props.profile);
      this.props.getFiles(newControlNumber);
      this.props.getHistory(newControlNumber);
      this.props.getCaseHeader(newControlNumber, (caseHeader) => {
        this.caseHeaderCallback(caseHeader);       
      });
      // Disconnect signalR message hub as its subscribed to the old control number
      if (this.signalrConnectionHub.current) {
        this.disconnectSignalR();
      }   
      if (this.props.caseEventMessagesEnabled) {
        this.startSignalRConnection();
      }
      // Preload Phoenix Forms to make everything faster
      initializePhoenix(newControlNumber);
    }
  }

  caseHeaderCallback(caseHeader) {
    if (isAppraisalCase(caseHeader)) {
      this.getAppraisalData(caseHeader);
    } else requestEnabledFeatures(caseHeader.policyInfo?.customerInfo?.customerNumber, (r) => this.setState({ enabledFeatures: r.features }), this.mounted);
  }

  splitAllFormsRight() {
    let formTabIndices = this.getCaseForms().reduce((acc, form, index) => {
      if (this.shouldPutInFormTab(form)) acc.push(index);
      return acc;
    }, []);
    this.setState({ rightSideFormIndices: formTabIndices });
  }

  onTabSplit(tabId, newLeftTabIds, newRightTabIds) {
    let isSplitting = !!newRightTabIds.length;
    this.setState({ isSplitting: isSplitting });

    if (tabId === LEFT_FORMS_TAB_ID) {
      this.splitAllFormsRight();
    }

    // if we are moving the right forms tab back to the left, combine it with the left
    if (newLeftTabIds.includes(RIGHT_FORMS_TAB_ID)) {
      this.setState({ rightSideFormIndices: [] });
    }

    this.saveTabPreferences(newLeftTabIds, newRightTabIds);
  }

  pushPhotosToPane() {
    const { caseHeader, roles, profile } = this.props;
    if (!this.pushedPhotosToPane &&
      this.tabControlMethods &&
      caseHeader &&
      caseHeader.caseInfo &&
      caseHeader.caseInfo?.primaryStatus &&
      ((caseHeader.caseInfo?.primaryStatus === PrimaryStatus.COMPLETED && isCustomer(roles)) ||
        // https://mueller-inc.atlassian.net/browse/SD-11762
        // Tried giving customers this right and removing the primary status check
        // But the requirements are very specific so couldn"t do that. More details in the task.
        (profile.rights.includes(FORM_PHOTO_VIEWER_SPLIT_VIEW)))
    ) {
      this.pushedPhotosToPane = true;
      this.tabControlMethods.pushTabRight("Photos");
    }
  }

  getAppraisalData(caseHeader) {
    const {
      caseForms,
      validateForms,
      getWorkflowStatus,
      getValidationStatus,
      enabledFeatures,
      fetchingEnabledFeatures,
      getEnabledFeatures,
    } = this.props;
    const compGridForm = caseForms.find(c => c.id === "ComparableswithComparableSearch");
    if (compGridForm?.compSearchForm?.displayNewComp) { // Has new comp grid right
      validateComparables(this.state.controlNumber, (payload) => {
        this.setState({ comparableValidationResult: payload });
      }, this.mounted);
    } else if (compGridForm) {
      validateComparablesPhoenix(this.state.controlNumber, (payload) => {
        this.setState({ comparableValidationResult: payload ? payload.results : [] });
      }, this.mounted);
    }
    if (!caseHeader) {
      return;
    }
    validateForms(caseHeader.caseInfo?.controlNumber);
    getWorkflowStatus(caseHeader.caseInfo?.controlNumber);
    getValidationStatus(caseHeader.caseInfo?.controlNumber);
    if ((!enabledFeatures || enabledFeatures.length === 0) && !fetchingEnabledFeatures) {
      getEnabledFeatures(caseHeader.policyInfo?.customerInfo?.customerNumber, this.enabledFeaturesCallback);
    } else if (enabledFeatures) {
      this.getAppraisalValidationResults(enabledFeatures);
    }
  }

  enabledFeaturesCallback(response) {
    if (response?.features.length) {
      this.getAppraisalValidationResults(response.features);
    }
  }

  getAppraisalValidationResults(enabledFeatures) {
    const {
      caseHeader,
      getValidationIssues,
      getGaarResults,
    } = this.props;
    if (enabledFeatures?.map(s => s.feature).includes(APPRAISAL_INTEGRATION_UCDP)) {
      getValidationIssues(caseHeader.caseInfo?.controlNumber);
    }
    if (enabledFeatures?.map(s => s.feature).includes(APPRAISAL_INTEGRATION_GAAR)
      && this.props.rights.includes(APPRAISAL_GAAR_VIEW)) {
      getGaarResults(caseHeader.caseInfo?.controlNumber);
    }
  }

  refresh() {
    this.props.getCaseHeader(this.state.controlNumber, this.caseHeaderCallback);
    this.props.getCaseTimeLogByCase(this.state.controlNumber, this.props.profile);
    if (this.props.lenderNextActions) {
      // History contains lenderNextActions which needs to be refreshed for appraisal cases
      this.props.getHistory(this.state.controlNumber);
    }
    this.caseHazardsRefresh();
  }

  caseHazardsRefresh() {
    if (this.props.caseHeader && !isAppraisalCase(this.props.caseHeader)) {
      this.props.getCaseHazards(this.state.controlNumber);
    }
  }

  caseFormsRefresh(){
    this.props.getCaseForms(this.state.controlNumber);
  }

  navBlock(location) {
    if (this.state.blocking) {
      if (location.pathname !== this.props.location.pathname) {
        return "You have unsaved changes. Are you sure you want to leave this page?";
      }
    }
  }

  closeBlock(e) {
    e.preventDefault();

    // close popups so they're not orphaned
    this.newWindow?.close();
    this.newWindow = null;
    this.sketchPopoutWindow?.close();
    this.sketchPopoutWindow = null;

    super.viewSwitch();
    let confirmationMessage = "\\o/";
    (e || window.event).returnValue = confirmationMessage;
    return confirmationMessage;
  }

  findSectionIndexByTitle(t) {
    this.nonFormControls.findIndex(({ title }) => title === t);
  }

  openFilePreview(file, urlWithSSO) {
    const newTab = {
      id: file.viewUrl,
      order: this.state.addTabCounter,
      title: file.name,
      children: <FilePreview
        displayname={file.name}
        path={urlWithSSO}
      />,
      canClose: true
    };
    this.setState({ addTabCounter: this.state.addTabCounter + 1 });
    this.tabControlMethods.addTabRight(newTab);
  }

  openCaseActionTab(component, title, id) {
    const newTab = {
      id,
      order: this.state.addTabCounter,
      title: title,
      children: component,
      canClose: true,
      closeOnUnmount: true
    };
    this.setState({ addTabCounter: this.state.addTabCounter + 1 });
    this.tabControlMethods.addTabRight(newTab);
  }

  openCaseMap(title, lat, lng) {
    const newTab = {
      id: `case_map_${this.state.addTabCounter + 1}`,
      order: this.state.addTabCounter,
      title: `${this.state.controlNumber} ${title}`,
      children: <TabMap lat={lat} lng={lng} />,
      canClose: true,
    };
    this.setState({ addTabCounter: this.state.addTabCounter + 1 });
    this.tabControlMethods.addTabRight(newTab);
  }

  openCompPhotoTool(photoURLs) {
    if (photoURLs) {
      let photos = {
        photoList: photoURLs.map((u, i) => ({
          photoUrl: u,
          photoID: i,
          photoTags: "",
          photoDescription: null,
          latitude: null,
          longitude: null
        }))
      };
      let newTab = {
        id: "Comp Photos",
        order: this.state.addTabCounter,
        title: "Photos",
        canClose: true,
        children: this.state.isPhotoTabPoppedOut ? this.getPhotoToolsOpenInOtherWindowMessage()
          : <PhotoTool
            controlNumber={this.state.controlNumber}
            photosOverride={photos}
            readOnly
            onPhotosPopOutButtonHit={this.onPopOutPhotosButtonHit}
            isPopOutWindow={this.state.photosPopOutWindowOpen}
            editedPhotoIds={this.state.editedPhotoIds}
            addEditedPhotoId={this.addEditedPhotoId}
          />,
      };
      this.setState({ addTabCounter: this.state.addTabCounter + 1 });
      this.tabControlMethods.closeTab(newTab.id);
      // TODO: Make these operations synchronous instead of setTimeOut
      setTimeout(() => this.tabControlMethods.addTabRight(newTab), 500);
    }
  }

  openPhotoTool(preselectedPhotoTags) {
    let newTab = {
      id: "Reo Repair Photos",
      order: this.state.addTabCounter,
      title: "Photos",
      canClose: true,
      children: this.state.isPhotoTabPoppedOut ? this.getPhotoToolsOpenInOtherWindowMessage()
        : <PhotoTool
          controlNumber={this.state.controlNumber}
          onPhotosPopOutButtonHit={this.onPopOutPhotosButtonHit}
          isPopOutWindow={this.state.photosPopOutWindowOpen}
          editedPhotoIds={this.state.editedPhotoIds}
          addEditedPhotoId={this.addEditedPhotoId}
          preselectedPhotoTags={preselectedPhotoTags}
        />,
    };
    this.setState({ addTabCounter: this.state.addTabCounter + 1 });
    let rightTab = this.tabControlMethods.getRightChild();
    if (!rightTab || rightTab.id !== newTab.id)
      this.tabControlMethods.addTabRight(newTab);
  }

  setInitialTab(id) {
    this.tabControlMethods.switchToTab(id);
  }

  mapCaseFormsToComps(form) {
    // Supports the ability to provide a component defined externally,
    if (this.state.controlNumber === 0) return;

    if (form.external && form.component) {
      if (form.id === "QACaseDetails") {
        return (<CaseDetails controlNumber={this.state.controlNumber} displayAddressMap={this.openCaseMap} />);
      }
      return form.component;
    }

    switch (form.id) {
      case "Header": {
        if (this.props.fetchingHeader) {
          return <MSpinner />;
        }
        return this.props.rights.includes(CASE_HEADER_RIGHT_FILTERED_VIEW)
          ? <CaseHeaderV2
            controlNumber={this.state.controlNumber}
            verticalDisplay={this.state.isSplitting}
            refreshMethod={() => this.handleControlNumber(this.state.controlNumber, true)}
          />
          : (
            <CaseHeader
              controlNumber={this.state.controlNumber}
              verticalDisplay={this.state.isSplitting}
              displayAddressMap={this.openCaseMap}
              qaTouches={this.props.qaTouches}
              openCaseTab={this.setInitialTab}
              onQaRejectionRespondSave={this.updateCaseActions}
              enabledFeatures={this.state.enabledFeatures || this.props.enabledFeatures}
            />
          );
      }
      case "BrokerCaseHeader": {
        if (this.props.fetchingHeader) {
          return <MSpinner />;
        }
        return (
          <BrokerCaseHeader
            controlNumber={this.state.controlNumber}
            verticalDisplay={this.state.isSplitting}
            openCaseTab={this.setInitialTab}
          />
        );
      }
      case "Files": {
        const { files } = this.props;
        const { controlNumber } = this.state;

        return (
          <FileManager
            controlNumber={controlNumber}
            files={files}
            onPreview={this.openFilePreview}
            canRegeneratePdf={this.props.rights.includes(CASE_FILE_REGENERATE_REPORT_PDF)}
          />
        );
      }
      case "History": {
        return <TabbedHistory controlNumber={this.state.controlNumber} />;
      }
      case "Photos": {
        const { controlNumber } = this.state;
        if (this.state.isPhotoTabPoppedOut)
          return this.getPhotoToolsOpenInOtherWindowMessage();
        return (
          <div id="mcaseview-photo-tool">
            <PhotoTool
              controlNumber={controlNumber}
              getControlMethods={this.setPhotoControlMethods}
              onPhotosPopOutButtonHit={this.onPopOutPhotosButtonHit}
              isPopOutWindow={this.state.photosPopOutWindowOpen}
              editedPhotoIds={this.state.editedPhotoIds}
              addEditedPhotoId={this.addEditedPhotoId}
            />
          </div>
        );
      }
      case "ComparableswithComparableSearch":
        return form.isReadOnly ? (
          <ReadOnlyCompSearch form={form} controlNumber={this.state.controlNumber.toString()} />
        ) : (
          <CompSearch
            form={form}
            formId={form.id}
            token={this.props.token}
            formStatus={form.formStatus}
            formStatusChange={this.props.formStatusChange}
            controlNumber={this.state.controlNumber.toString()}
            makeToast={this.props.makeToast}
            userEmail={this.props.profile.email}
            caseHeader={this.props.caseHeader}
            comparable={this.props.comparable}
            importMismo={this.props.importMismo}
            allowMismoImport={form.options && form.options.includes("AllowMismoImport;")}
            onPhotoView={this.openCompPhotoTool}
            onFormSave={this.updateCaseActions}
          />
        );
      case "TrendCharts":
        return (
          <TrendCharts charts={form.trendCharts} token={this.props.token} />
        );
      case "Sketch": {
        return (<Sketch 
          controlNumber={this.state.controlNumber} 
          readOnly={form.isReadOnly}
          isSketchPopOutOpen={this.state.isSketchPopOutOpen}
          onOpenSketchPopout={this.openSketchPopout}
        />);
      }
      case "CubiCasa": {
        return <CubiCasaSketch controlNumber={this.state.controlNumber} />;
      }
      case "Validation": {
        return (
          <Validation
            controlNumber={parseInt(this.state.controlNumber, 10)}
            caseForms={this.props.caseForms}
            caseType={getCaseType(this.props.caseHeader?.policyInfo?.customerInfo?.customerType)}
            refreshMethod={this.refresh}
            FLCview={true}
            updateControlNumber={this.handleControlNumber}
            openCaseActionTab={this.openCaseActionTab}
            closeTab={(tabId) => this.tabControlMethods.closeTab(tabId, true)}
            comparableValidationResult={this.state.comparableValidationResult}
          />
        );
      }
      case "UniformResidentialAppraisal(1004Hybrid/70H)V4":
      case "UniformResidentialAppraisal(1004Hybrid/70H)V5": {
        return (
          <Appraisal1004p70h
            controlNumber={this.state.controlNumber}
            onChange={() => this.formStatusChange(form, "dirty", form.pnxForm.formId)}
            onSave={() => { this.formStatusChange(form, "clean", form.pnxForm.formId); this.updateCaseActions(); }}
            readOnly={form.isReadOnly} />
          );
      }
      case "UniformResidentialAppraisal(1004P)V3":
      case "UniformResidentialAppraisal(1004P)V4": {
        return (
          <Appraisal1004p
            controlNumber={this.state.controlNumber}
            onChange={() => this.formStatusChange(form, "dirty", form.pnxForm.formId)}
            onSave={() => { this.formStatusChange(form, "clean", form.pnxForm.formId); this.updateCaseActions(); }}
            readOnly={form.isReadOnly} />
          );
      }
      case "UniformResidentialAppraisal(1004Desktop)V1":
      case "UniformResidentialAppraisal(1004Desktop)V2":
        return (
          <Appraisal1004Desktop
            controlNumber={this.state.controlNumber}
            onChange={() => this.formStatusChange(form, "dirty", form.pnxForm.formId)}
            onSave={() => this.formStatusChange(form, "clean", form.pnxForm.formId)}
            readOnly={form.isReadOnly}
          />
        );
      case "UniformResidentialAppraisal(1004Desktop/70D)V1": {
          return (
            <Appraisal1004Desktop70D
              controlNumber={this.state.controlNumber}
              onChange={() => this.formStatusChange(form, "dirty", form.pnxForm.formId)}
              onSave={() => { this.formStatusChange(form, "clean", form.pnxForm.formId); this.updateCaseActions(); }}
              readOnly={form.isReadOnly} />
            );
      }
      case "CaseReview": {
        const { controlNumber } = this.state;
        return <ReviewCase {...{ controlNumber }} />;
      }
      case "1004DSurvey": {
        return (<Appraisal1004d
          controlNumber={this.state.controlNumber}
          onChange={() => this.formStatusChange(form, "dirty", form.pnxForm.formId)}
          onSave={() => this.formStatusChange(form, "clean", form.pnxForm.formId)}
        />);
      }
      case "Calc": {
        return <Calc controlNumber={this.state.controlNumber} />;
      }
      case "Value360": {
        return (
            <ThreeSixtyValue controlNumber={this.state.controlNumber} className="md-cell md-cell--12"/>
        );
      }
      case "E2Value": {
        return (
          <Cell size={12} className="width-unset flex-child flex-parent flex-column">
              <E2Value controlIdNumber={this.state.controlNumber} />
          </Cell>
      );
      }
      case "UcdpSubmittal": {
        return <UcdpSubmittalForm controlNumber={this.state.controlNumber} />;
      }
      case "Exports": {
        return <Exports controlNumber={this.state.controlNumber} />;
      }      
      case "REO/MITAppraisalV1":
      case "REO/MITAppraisalV2": {
        return (<ReoMit
          controlNumber={this.state.controlNumber}
          onChange={() => this.formStatusChange(form, "dirty", form.pnxForm.formId)}
          onSave={() => this.formStatusChange(form, "clean", form.pnxForm.formId)}
          readOnly={form.isReadOnly} />);
      }
      case "Reo Repair":
        return <ReoRepair controlNumber={this.state.controlNumber} openPhotoTool={this.openPhotoTool} />;
      case "Mit Update":
        return <MitUpdate controlNumber={this.state.controlNumber} openPhotoTool={this.openPhotoTool} />;
      case "AppraiserProfile":
        return (<AppraiserProfilePanel
          id={this.props.caseHeader?.caseInfo?.appraiserId}
          internetUserIdForPanel={this.props.caseHeader?.caseInfo?.appraiserInternetUserId}
          showHeaderButton={false} />);
      case "AppraiserOrderRequirements":
        return (<OrderRequirements pdf={form.originalPayload} />);
      case "RCTFrameWrapper":
        return (<RctFrameWrapper form={form} />);
      case "QACaseAudit":
        return <QACaseAudit controlNumber={this.state.controlNumber} />;
      default:
        return (
          <PhoenixFormInstance 
            controlIdNumber={this.state.controlNumber}
            form={form.pnxForm}
            readonly={form.isReadOnly}
          />);
    }
  }

  getPhotoToolsOpenInOtherWindowMessage() {
    return (
      <div className="photos-open-in-other-window-message">
        <p>Photos tool open in other window</p>
        <Button
          primary
          raised
          onClick={() => {
            this.setState({ isPhotoTabPoppedOut: false});
            this.newWindow?.close();
            this.newWindow = null;
          }}>
          Close window
        </Button>
      </div>
    );
  }

  setPhotoControlMethods(cm) {
    this.photoToolControlMethods = cm;
    if (this.selectedPhotoIndex != null) this.photoToolControlMethods.setSelectedPhotoIndex(this.selectedPhotoIndex);
  }

  cleanForm(form) {
    let phoenixId = form.pnxForm ? form.pnxForm.formId : null;
    this.props.formStatusChange(form.title, "clean", phoenixId);
    if (form.id === "ComparableswithComparableSearch" && form.formStatus === "openedComps"){
      this.props.formStatusChange(form.title, "closedComps", phoenixId);
      return this.props.makeToast("CA comp search window automatically closed.", "success");
    }
  }

  // Wrapped this in a function that only changes the status if it needs changing so we dont do useless re-renders
  formStatusChange(form, status, phoenixId) {
    if (form.formStatus !== status) this.props.formStatusChange(form.title || form.id, status, phoenixId);
  }

  getUnmountWarning(form) {
    if (form.formStatus === "openedComps" && form.id === "ComparableswithComparableSearch") return `Are you sure you want to leave ${form.title}? The CA comp search window will automatically close.`;
    else return `Are you sure you want to leave ${form.title}? There are unsaved changes`;
  }

  getLeftSideFormIndexFromTabIndex(i) {
    let incByOne = this.state.tabIndexInPanel != null && i >= this.state.tabIndexInPanel;
    return i + (incByOne ? 1 : 0);
  }

  isFormStatusClean(status) {
    return status !== "dirty" && status !== "openedComps";
  }

  canUnmountForm(status) {
    return this.isFormStatusClean(status) || status === "needsRefresh";
  }

  fixFormTitle(form) {
    // We wanted any form that had the text PhoenixSketch in it to just have its tab say sketch, this logic covers the following forms:
    // PhoenixSketch, PhoenixSketch Brush, PhoenixSketch Site Layout, PhoenixSketch Commercial Layout, PhoenixSketch Roof Geometry, PhoenixSketch V2, Phoenixsketch Appraisal
    if (form.title.toLowerCase().indexOf("phoenixsketch") > -1) return "Sketch";
    return form.title;
  }

  splitFormsTab(pushTabToRight, originalFormIndex) {
    if (pushTabToRight) {
      this.setState({ rightSideFormIndices: [...this.state.rightSideFormIndices, originalFormIndex] });
    } else {
      this.setState({ rightSideFormIndices: this.state.rightSideFormIndices.filter(i => i !== originalFormIndex) });
    }
  }

  shouldPutInFormTab(form) {
    return form.isPhoenixForm || form.id === "RCTFrameWrapper";
  }

  getCaseForms() {
    // Externally Supplied Form Set? Use that
    return this.props.externalFormSet.length
            ? [...this.props.externalFormSet, ...this.props.caseForms.filter(this.shouldPutInFormTab)]
            : [...this.props.caseForms];
  }

  /**
   * This logic could be simplified, but i was worried that we could lose tabs somehow with simpler methods
   * If we werent careful about that, we could end up with QA agents having no way to see a tab
   * This method ensures that no tabs are ever lost, and also that there will never be duplicates, no matter how bad the data coming in is
   * @param {"current" | "preference"} authority
   */
  mergeTabIds(currentLeftTabIds, currentRightTabIds, preferenceLeftTabIds, preferenceRightTabIds, authority) {

    
    currentRightTabIds = currentRightTabIds.map(t => t === RIGHT_FORMS_TAB_ID ? LEFT_FORMS_TAB_ID : t);
    preferenceRightTabIds = preferenceRightTabIds.map(t => t === RIGHT_FORMS_TAB_ID ? LEFT_FORMS_TAB_ID : t);

    let allTabIds = new Set([...currentLeftTabIds, ...currentRightTabIds, ...preferenceLeftTabIds, ...preferenceRightTabIds]);

    let mergedLeft = [];
    let mergedRight = [];

    /**
     * @param {"left" | "right"} side
     */
    const pushTab = (side, tabId) => {
      if (allTabIds.has(tabId)) {
        (side === "left" ? mergedLeft : mergedRight).push(tabId);
        allTabIds.delete(tabId);
      }
    };

    let sourceLeft;
    let sourceRight;
    let remainingLeft;
    let remainingRight;

    if (authority === "current") {
      sourceLeft = currentLeftTabIds;
      sourceRight = currentRightTabIds;
      remainingLeft = preferenceLeftTabIds;
      remainingRight = preferenceRightTabIds;
    } else {
      sourceLeft = preferenceLeftTabIds;
      sourceRight = preferenceRightTabIds;
      remainingLeft = currentLeftTabIds;
      remainingRight = currentRightTabIds;
    }

    sourceLeft.forEach(t => pushTab("left", t));
    sourceRight.forEach(t => pushTab("right", t));
    remainingLeft.forEach(t => pushTab("left", t));
    remainingRight.forEach(t => pushTab("right", t));
    
    mergedRight = mergedRight.map(t => t === LEFT_FORMS_TAB_ID ? RIGHT_FORMS_TAB_ID : t);

    return {
      leftTabIds: mergedLeft,
      rightTabIds: mergedRight,
    };
  }

  getTabs() {
    if (!this.props.fetchingCaseForms) {
      const formsTabIndex = 2;
      let caseForms = this.getCaseForms();
      
      if (!caseForms.length) return;

      let nonFormControls = [];

      let leftFormControls = [];
      let rightFormControls = [];

      // Add "Reo Repair" form which is not a separate phoenix form but is still displayed in a separate tab in react
      if (caseForms.find(c => c.id.includes("REO/MITAppraisalV"))) {
        let isMit = this.props.caseHeader?.caseInfo?.currentInspectionType?.code === "INTERIOR_DESKTOP"
          && this.props.caseHeader?.policyInfo?.customerInfo?.customerNumber === "1546";
        // add it after the comp grid tab
        caseForms.splice(caseForms.findIndex(c => c.id === "ComparableswithComparableSearch") + 1, 0, {
          id: isMit ? "Mit Update" : "Reo Repair",
          // Apologies for checking inspection type and customer number here but its just used for a display label and making a property for it in the model felt like a crime
          title: isMit ? "MIT Appraisal Updates" : "REO Appraisal Repairs",
          formStatus: "clean",  // Its not a phoenix form so fake status
          isPhoenixForm: true
        });
      }
      // filter CC Reconciliation forms if user is Valuation Customer, Valuation Customer Manager, Customer, or Customer Admin and case is not completed
      let ccReconciliationFormPresent = caseForms.find(cf => cf.id.includes("CCReconciliation"));
      if (ccReconciliationFormPresent) {
        let isCaseCompleted = this.props.caseHeader.caseInfo?.appraisalSurveyInfo?.workflowStatusCode.toLowerCase() === "completed";
        if (isValOrCusRole(this.props.profile.roles) && !isCaseCompleted) {
          caseForms.splice(caseForms.findIndex(c => c.id === "CCReconciliation-Liquidation" || c.id === "CCReconciliation" || c.id === "CCReconciliation-AsIs/Repaired"), 1);
        }
      }
      if (this.props.caseHeader?.caseInfo?.appraiserId && this.props.profile.rights.includes(APPRAISER_VIEW)) {
        caseForms.push({ id: "AppraiserProfile", title: "Appraiser" });
      }

      caseForms.forEach((f, i) => {
        let caseFormSection = {
          id: f.id,
          title: this.fixFormTitle(f),
          children: this.mapCaseFormsToComps(f),
          defaultExpanded: true,
          canUnmountChildWarning: this.getUnmountWarning(f),
          canUnmountChildStatus: this.canUnmountForm(f.formStatus) ? UNMOUNT_STATUS_ALLOW : UNMOUNT_STATUS_WARNING,
          onChildUnmount: () => this.cleanForm(f),
        };
        if (this.shouldPutInFormTab(f)) {
          if (this.state.rightSideFormIndices.includes(i)) {
            rightFormControls.push(caseFormSection);
            caseFormSection.actions = [{ code: ACTION_SPLIT_LEFT, onClick: () => this.splitFormsTab(false, i) }];
          } else {
            leftFormControls.push(caseFormSection);
            caseFormSection.actions = [{ code: ACTION_SPLIT, onClick: () => this.splitFormsTab(true, i) }];
          }
        } else {
          nonFormControls.push(caseFormSection);
        }
      });

      let combinedSectionWarning = [];
      let unmountFunctions = [];
      leftFormControls.forEach((s, i) => {
        if (s.canUnmountChildStatus === UNMOUNT_STATUS_WARNING) {
          combinedSectionWarning.push(<div key={i}>{`Warning from: ${s.title}`}<br />{s.canUnmountChildWarning}<br /><br /></div>);
          unmountFunctions.push(s.onChildUnmount);
        }
      });

      if (leftFormControls?.length) {
        nonFormControls.splice(formsTabIndex, 0, {
          id: LEFT_FORMS_TAB_ID,
          title: "Forms",
          children: <MSectionCollection
            sections={leftFormControls ?? []}
            defaultMode={MSECTION_MODE_TAB}
            tabModeCollapsible={false}
            fullHeight
            tracking={{ parentView: "MCaseView", parentSection: "Forms", controlNumber: this.state.controlNumber }}
            refresh={this.caseFormsRefresh}
          />,
          defaultExpanded: false,
          canUnmountChildWarning: combinedSectionWarning,
          canUnmountChildStatus: combinedSectionWarning.length ? UNMOUNT_STATUS_WARNING : UNMOUNT_STATUS_ALLOW,
          onChildUnmount: () => unmountFunctions.forEach(f => f()),
        });
      }

      if (rightFormControls.length) {
        nonFormControls.splice(formsTabIndex, 0, {
          id: RIGHT_FORMS_TAB_ID,
          title: "Forms",
          children: <MSectionCollection
            sections={rightFormControls}
            defaultMode={MSECTION_MODE_TAB}
            tabModeCollapsible={false}
            fullHeight
          />,
          defaultExpanded: false,
          canUnmountChildWarning: combinedSectionWarning,
          canUnmountChildStatus: combinedSectionWarning.length ? UNMOUNT_STATUS_WARNING : UNMOUNT_STATUS_ALLOW,
          onChildUnmount: () => unmountFunctions.forEach(f => f()),
        });
      }
      // Move Exports tab after CubiCasa tab if present
      let cubiCasaIndex = nonFormControls.findIndex(i => i.id === "CubiCasa");
      let exportsIndex = nonFormControls.findIndex(i => i.id === "Exports");
      if (cubiCasaIndex !== -1 && exportsIndex !== -1) {
        if (nonFormControls[cubiCasaIndex + 1].id !== "Exports") {
          let exportsTab = nonFormControls.find(f => f.id === "Exports");
          nonFormControls.splice(exportsIndex, 1);
          nonFormControls.splice(cubiCasaIndex + 1, 0, exportsTab);
        }
      }

      const revisionsRejectIndex = nonFormControls.findIndex(i => i.id === CASE_DATA_REVISIONS_REJECTION);
      if (revisionsRejectIndex > -1) {
        // Need to move this before the forms tab when returned to QA from a rejections
        const dataRevisionsTab = nonFormControls.splice(revisionsRejectIndex, 1)[0];
        nonFormControls.splice(formsTabIndex - 1, 0, dataRevisionsTab);
      }

      nonFormControls = nonFormControls.map((c, i) => ({ ...c, order: i }));

      if (!this.lastRenderedTabs?.find(t => t.id === RIGHT_FORMS_TAB_ID) && nonFormControls.find(t => t.id === RIGHT_FORMS_TAB_ID)) {
        // need to wait till we render, then call this, theres really no other way to do this right now, see the comment elsewhere in this file where we do this "TODO: Make these operations synchronous instead of setTimeOut"
        setTimeout(() => this.tabControlMethods.pushTabRight(RIGHT_FORMS_TAB_ID), 100);
      }

      this.lastRenderedTabs = nonFormControls;

      return nonFormControls;
    }
    return null;
  }

  // debounced in the constructor
  saveTabPreferences(newLeftTabIds, newRightTabIds) {
    if (this.props.preferenceNameToSaveTabOrder) {
      let mergedTabs = this.mergeTabIds(newLeftTabIds, newRightTabIds, this.state.loadedTabPreference?.leftTabIds, this.state.loadedTabPreference?.rightTabIds, "current");
      savePreference(this.props.preferenceNameToSaveTabOrder, JSON.stringify({ leftTabIds: mergedTabs.leftTabIds, rightTabIds: mergedTabs.rightTabIds }));
    }
  }

  getTabUnmountStatus(id) {
    const actionTabIds = [
      CASE_EMAIL_TAB_ID,
      CUSTOMER_SERVICE_EMAIL_TAB_ID,
      APPRAISAL_PORT_HOLD_TAB_ID,
      APPRAISAL_PORT_MESSAGE_TAB_ID
    ];
    if (actionTabIds.includes(id)) {
      return { canUnmountChildWarning: "Message has not been sent. Are you sure you want to close?", canUnmountChildStatus: UNMOUNT_STATUS_WARNING };
    }

    let tab = this.lastRenderedTabs.find(t => t.id === id);
    if (!tab) return null;
    return { canUnmountChildStatus: tab.canUnmountChildStatus, canUnmountChildWarning: tab.canUnmountChildWarning };
  }

  onTabUnmount(id) {
    let tab = this.lastRenderedTabs.find(t => t.id === id);
    if (!tab) return;
    if (tab.onChildUnmount) tab.onChildUnmount(id);
  }

  updateCaseActions() {
    let leftChild = this.tabControlMethods.getLeftChild();
    let rightChild = this.tabControlMethods.getRightChild();
    if ((leftChild && leftChild.id === "Validation") || (rightChild && rightChild.id === "Validation")) {
      this.refresh();
    }
  }

  onPopOutPhotosButtonHit() {
    this.setState({ isPhotoTabPoppedOut: true });
  }

  addEditedPhotoId(editedPhotoId) {
    this.setState((prevState) => ({ editedPhotoIds: [...prevState.editedPhotoIds, editedPhotoId] }));
  }

  openSketchPopout(sketchUri) {
    if (!this.sketchPopoutWindow) {
      const url = `${sketchUri}&SSO=${this.props.token}&DisplayMode=Standard`;
      this.sketchPopoutWindow = window.open(url, "_blank", "alwaysRaised:true,height:768px,width:1024px,resizable:true");
      this.setState({ isSketchPopOutOpen: true });
      
      // Poll for window closure
      const pollInterval = setInterval(() => {
        if (this.sketchPopoutWindow && this.sketchPopoutWindow.closed) {
          clearInterval(pollInterval);
          this.closeSketchPopout();
        }
      }, 1000);
    }
  }

  closeSketchPopout() {
    this.sketchPopoutWindow?.close();
    this.sketchPopoutWindow = null;
    this.setState({ isSketchPopOutOpen: false });
  }

  render() {
    let tabs = this.getTabs();
    const willRenderNewWindow = this.state.isPhotoTabPoppedOut && !this.newWindow;

    if (!tabs) return <MSpinner />;

    return (
      <>
        {willRenderNewWindow &&
        <WindowContext.Consumer>
          {(value) => {
            this.newWindow = value.openNewWindowWithSSO(
              "/photo/pop-out",
              {
                features: {
                  width: 1000,
                  height: 725,
                },
                hideSidebar: true,
                hideHeader: true,
                sendDataToWindow: this.state.editedPhotoIds,
                onWindowClosed: () => {
                  this.newWindow = null;
                  this.setState({ isPhotoTabPoppedOut: false });
                }
              });
            return null;
          }}
        </WindowContext.Consumer>}
        {this.state.showCaseWatchDialog && this.getCaseWatchDialog()}
        <WrappedMSplitTabView
          tabs={tabs}
          defaultRightTabIds={this.props.forcePushToPane}
          onTabSplit={this.onTabSplit}
          firstChildInitialSize={this.props.firstChildInitialSize}
          setControlMethods={cm => this.tabControlMethods = cm}
          getTabUnmountStatus={this.getTabUnmountStatus}
          onTabUnmount={this.onTabUnmount}
          initialTabs={this.state.initialTabs}
        />
        {this.props.canEditCaseForms &&
        <ManageFormsDialog
          controlNumber={this.props.controlNumberOverride ?? this.props.controlNumber}
        />}
        

      </>
    );
  }
}

MCaseView.defaultProps = {
  externalFormSet: [],
  forcePushToPane: [],
  firstChildInitialSize: null,
};

MCaseView.propTypes = {
  controlNumberOverride: PropTypes.number, // Pass this in to override the control number because the controlNumber prop is linked to redux and i cant seem to override it
  controlNumber: PropTypes.number, // Set by router or by props
  changeControlNumber: PropTypes.func.isRequired,
  fetchingCaseForms: PropTypes.bool.isRequired,
  caseForms: PropTypes.array.isRequired,
  fetchingHeader: PropTypes.bool.isRequired,
  caseHeader: PropTypes.object.isRequired,
  files: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  token: PropTypes.string.isRequired,
  profile: PropTypes.object.isRequired,
  getCaseForms: PropTypes.func.isRequired,
  getCaseHeader: PropTypes.func.isRequired,
  getFiles: PropTypes.func.isRequired,
  getHistory: PropTypes.func.isRequired,
  getValidationStatus: PropTypes.func.isRequired,
  getValidationIssues: PropTypes.func,
  savePNXFormSuccess: PropTypes.func.isRequired,
  savePNXFormFail: PropTypes.func.isRequired,
  savePNXFormsMessage: PropTypes.func.isRequired,
  formStatusChange: PropTypes.func.isRequired,
  getCaseTimeLogByCase: PropTypes.func.isRequired,
  validationMessage: PropTypes.func.isRequired,
  validateForms: PropTypes.func.isRequired,
  comparable: PropTypes.object.isRequired,
  importMismo: PropTypes.func.isRequired,
  makeToast: PropTypes.func.isRequired,
  getWorkflowStatus: PropTypes.func,
  roles: PropTypes.array,
  externalFormSet: PropTypes.array,
  forcePushToPane: PropTypes.array,
  summaryViewEnabled: PropTypes.bool,
  firstChildInitialSize: PropTypes.string,
  qaTouches: PropTypes.array,
  initialTabs: PropTypes.object,
  getEnabledFeatures: PropTypes.func,
  enabledFeatures: PropTypes.array,
  fetchingEnabledFeatures: PropTypes.bool,
  getGaarResults: PropTypes.func,
  lenderNextActions: PropTypes.array,
  getCaseHazards: PropTypes.func,
  internetUserId: PropTypes.number,
  appendHeader: PropTypes.func,
  clearHeaderDefinitions: PropTypes.func,
  hasInspectionWatchRight: PropTypes.bool,
  hasAppraisalWatchRight: PropTypes.bool,
  signalrToken: PropTypes.string,
  initSignalR: PropTypes.func,
  caseEventMessagesEnabled: PropTypes.bool,
  canEditCaseForms: PropTypes.bool,
  isCompletingCase: PropTypes.bool,
  isRejectingCase: PropTypes.bool,
  isEscalatingCase: PropTypes.bool,
  preferenceNameToSaveTabOrder: PropTypes.string,
};

const mapStateToProps = state => {
  return {
    controlNumber: state.caseDetails.controlNumber,
    fetchingCaseForms: state.caseForms.fetchingCaseFormsList,
    caseForms: state.caseForms.caseFormsList,
    fetchingHeader: state.caseForms.fetchingHeader,
    caseHeader: state.caseForms.caseHeader,
    files: state.caseForms.files,
    token: state.user.profile.token,
    profile: state.user.profile,
    comparable: state.comparable,
    roles: state.user.profile.roles,
    rights: state.user.profile.rights,
    summaryViewEnabled: state.qualityAssurance.qaVariables.summaryViewEnabled,
    caseEventMessagesEnabled: state.qualityAssurance.qaVariables.subscribeToCaseEventMessages,
    value360: state.qualityAssurance.value360,
    enabledFeatures: state.customer.enabledFeatures,
    fetchingEnabledFeatures: state.customer.fetchingEnabledFeatures,
    lenderNextActions: state?.caseForms?.caseHistory?.lenderNextActions,
    internetUserId: state.user.profile.internetUserId,
    hasInspectionWatchRight: userHasRight(INSPECTION_EVENT_WATCH)(state),
    hasAppraisalWatchRight: userHasRight(APPRAISAL_EVENT_WATCH)(state),
    signalrToken: state.user.profile.token,
    canEditCaseForms: userHasRight(CASE_FORMS_MAINTENANCE)(state),
    isCompletingCase: state.qualityAssurance.qaVariables.completingCase,
    isRejectingCase: state.qualityAssurance.qaVariables.rejectingCase,
    isEscalatingCase: state.qualityAssurance.qaVariables.escalatingCase,
  };
};

const mapDispatchToProps = dispatch => ({
  changeControlNumber(id) {
    dispatch(changeControlNumber(id));
  },
  getCaseForms(controlNumber) {
    dispatch(getCaseForms(controlNumber));
  },
  getFiles(controlNumber) {
    dispatch(getFiles(controlNumber));
  },
  getHistory(controlNumber) {
    dispatch(getHistory(controlNumber));
  },
  getValidationStatus(controlIdNumber) {
    dispatch(getValidationStatus(controlIdNumber));
  },
  getValidationIssues(controlIdNumber) {
    dispatch(getValidationIssues(controlIdNumber));
  },
  savePNXFormSuccess(msg) {
    dispatch(savePNXFormSuccess(msg));
  },
  savePNXFormFail(text) {
    dispatch(savePNXFormFail(text));
  },
  savePNXFormsMessage(text, type) {
    dispatch(savePNXFormsMessage(text, type));
  },
  formStatusChange(formName, status, id) {
    dispatch(formStatusChange(formName, status, id));
  },
  getCaseTimeLogByCase(controlIdNumber, profile) {
    const validRights = [
      APPRAISER_TIMELOGS_APPROVE,
      APPRAISER_TIMELOGS_APPROVE_VIEW,
      BUSOPS_TIMELOGS_APPROVE,
      BUSOPS_TIMELOGS_VIEW,
      CASE_TIMELOGS_VIEW_ALL,
      FIELD_REP_TIMELOGS_APPROVE_VIEW,
      MY_TIMELOGS_VIEW
    ];
    if (validRights.some(r => profile.rights.includes(r))) {
      dispatch(getCaseTimeLogByCase(controlIdNumber));
    }
  },
  validateForms(controlIdNumber, formId = null, callback = null) {
    dispatch(validateForms(controlIdNumber, formId, callback));
  },
  validationMessage(text, type) {
    dispatch(validationMessage(text, type));
  },
  makeToast(text, type) {
    responseHandler.customToast(text, type, dispatch);
  },
  getCaseHeader(controlIdNumber, callback) {
    dispatch(getCaseHeader(controlIdNumber, callback));
  },
  getWorkflowStatus(controlIdNumber) {
    dispatch(getWorkflowStatus(controlIdNumber));
  },
  importMismo(controlNumber, file, fileId, uploadFinishedCallback) {
    dispatch(importMismo(controlNumber, file, fileId, uploadFinishedCallback));
  },
  getEnabledFeatures(customerNumber, callback) {
    dispatch(getEnabledFeatures(customerNumber, callback));
  },
  getGaarResults(controlIdNumber) {
    dispatch(getGaarResults(controlIdNumber));
  },
  getCaseHazards(controlNumber) {
    dispatch(getCaseHazards(controlNumber));
  },
  appendHeader(headerDefinitions) {
    dispatch(appendHeader(headerDefinitions));
  },
  clearHeaderDefinitions(headerDefinitions) {
    dispatch(clearHeaderDefinitions(headerDefinitions));
  },
  initSignalR(signalrConnectionHub) {
    return dispatch(signalrConnectionHub);
  },
  clearHeader() {
    dispatch(clearHeader());
  },
  manageForms(payload) {
      dispatch(manageFormsRedux(payload));
    },
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(MCaseView));


